import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ReturnObject } from '../../models/returnObject';
import { Project } from '../../models/project';
import { APIService } from '../api.service';

@Injectable()
export class ProjectService {

    constructor(
        private api: APIService) {
    }

    getProjects(weekNo: string): Observable<ReturnObject<Project[]>> {
        return this.api.getAPI(`project/${weekNo}`);
    }

    getAllProjects(): Observable<ReturnObject<Project[]>> {
        return this.api.getAPI(`project`);
    }    
}
